// Module
var code = "<ng2-bm-ng-select [items]=\"vm.persons\" [selected]=\"vm.selected.id || vm.selected.name\" [tagging]=\"true\" [multiple]=\"false\" [virtual-scroll]=\"false\" [placeholder]=\"'Select or enter a new owner name'\" (change-selected)=\"vm.onChange($event)\"> </ng2-bm-ng-select> ";
// Exports
module.exports = code;